import React from "react";
import { user } from "../../constants";

const EditProfile = ({ show, setShow }) => {
  return (
    <>
      {show ? (
        <div className="profile-modal-overlay">
          <div className="profile-modal-container">
            <div className="close-profile">
              <button
                className="profile-close-button"
                onClick={() => setShow(false)}
              >
                <img src="/icons/cancel.svg" alt="" />
              </button>
            </div>
            <h2 className="profile-modal-title">Profile</h2>
            <div className="profile-pic-section">
              <div className="profile-pic-wrapper">
                <div className="profile-border">
                  <div
                    className="profile-image"
                    style={{ backgroundImage: `url(${user.profileImage})` }}
                  />
                </div>{" "}
                <button className="profile-edit-pic-button">
                  <img src="/icons/edit.svg" alt="edit" />
                </button>
              </div>
              <p className="profile-username">@abraham6438</p>
            </div>
            <div className="profile-form-section">
              <input
                type="text"
                placeholder="Username"
                className="profile-form-input"
              />
              <p className="profile-hint">
                Username can be changed once per day
              </p>
              <textarea
                placeholder="Bio"
                className="profile-form-input profile-bio-input"
              ></textarea>
              <button className="profile-save-button">Save</button>
            </div>
          </div>
        </div>
      ) : null}
    </>
  );
};

export default EditProfile;
